'use client'

import { Header } from '@/components/v3/organisms/navigation/header/header'
import { MainNavMobile } from '@/components/v3/organisms/navigation/main-nav-mobile/main-nav-mobile'
import { useState } from 'react'
import { MainNav } from '@/components/v3/organisms/navigation/main-nav/main-nav'
import { Article } from '@/types/Article'
import { UiPlacement, UiPlacementResponse } from '@/types/api/ui-placement'
import { Supplier } from '@/types/Supplier'
import { VisibleOn } from '@/components/v3/atoms/visible-on'
import { groupMenuItems } from '@/v2/fetch/helpers/fetch-menu-items'
import { useShopMegaMenu } from '@/hooks/use-shop-mega-menu'

export type MenuItemsType = {
  mainItem: UiPlacement
  subcategories: UiPlacement[]
}[]

type Props = {
  featuredArticles?: Article[]
  menuItems: UiPlacementResponse['data']
  navbarSuppliers?: Supplier[]
  navbarVenues?: Supplier[]
}

export const NavigationIndex = ({
  featuredArticles,
  menuItems,
  navbarSuppliers,
  navbarVenues,
}: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const groupedMenuItems = groupMenuItems(menuItems)
  // Fetched here rather than in each nav: this component serves both the
  // SWR-driven wrapper and the prerendered navigation data used on article
  // pages, so one call covers every page and both breakpoints.
  const shopMegaMenu = useShopMegaMenu()

  return (
    <>
      <Header onHamburgerIconClick={() => setIsMenuOpen(true)} />

      <VisibleOn desktop>
        <MainNav
          featuredArticles={featuredArticles}
          navbarSuppliers={navbarSuppliers}
          navbarVenues={navbarVenues}
          menuItems={groupedMenuItems}
          shopMegaMenu={shopMegaMenu}
        />
      </VisibleOn>

      <VisibleOn tablet mobile>
        <MainNavMobile
          isMenuOpen={isMenuOpen}
          onOutsideNavClick={() => setIsMenuOpen(false)}
          menuItems={groupedMenuItems}
          shopMegaMenu={shopMegaMenu}
        />
      </VisibleOn>
    </>
  )
}
